import $ from 'jquery';
import ApexCharts from 'apexcharts';

$(function () {
    const $container = $('#fee-impact-app');
    if (!$container.length) return;

    let currency = $container.data('currency') || 'USD';
    let symbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : currency === 'PLN' ? 'zł' : '₴';
    let chartInstance = null;

    const textMoreCurrencies = $container.data('text-more-currencies') || 'Ще валюти';
    const textMoreShort = $container.data('text-more-short') || 'Ще';

    const $initBtn = $('#fee-currency-tabs button.active');
    if ($initBtn.length) {
        currency = $initBtn.data('currency-code') || currency;
        symbol = $initBtn.data('symbol') || symbol;
    }

    const culture = $container.data('culture') || 'uk-UA';
    const localeMap = { 'uk': 'uk-UA', 'pl': 'pl-PL', 'de': 'de-DE', 'es': 'es-ES', 'it': 'it-IT', 'en': 'en-US' };
    const dateLocale = localeMap[culture] || 'en-US';

    const seriesGross = $container.data('series-gross') || 'Без комісій';
    const seriesEtf = $container.data('series-etf') || 'З індексним ETF';
    const seriesActive = $container.data('series-active') || 'З активним фондом банку';
    const unitYears = $container.data('unit-years') || 'р.';
    const unitPerMonth = $container.data('unit-per-month') || '/ міс';
    const realityTmpl = $container.data('reality-tmpl') || 'Різниця у комісії всього в {feeDiff}% щороку зменшує підсумковий капітал на {lostPct}% ({lostAmount}), оскільки списані гроші більше ніколи не працюють на вас.';

    const $initialRange = $('#fee-initial-range');
    const $initialDisplay = $('#fee-initial-display');

    const $monthlyRange = $('#fee-monthly-range');
    const $monthlyDisplay = $('#fee-monthly-display');

    const $returnRange = $('#fee-return-range');
    const $returnDisplay = $('#fee-return-display');

    const $yearsRange = $('#fee-years-range');
    const $yearsDisplay = $('#fee-years-display');

    const $etfRange = $('#fee-etf-range');
    const $etfDisplay = $('#fee-etf-display');

    const $activeRange = $('#fee-active-range');
    const $activeDisplay = $('#fee-active-display');

    function formatMoney(num) {
        return Math.round(num).toLocaleString(dateLocale) + ' ' + symbol;
    }

    function calculate() {
        const initial = parseFloat($initialRange.val()) || 10000;
        const monthly = parseFloat($monthlyRange.val()) || 500;
        const grossReturn = (parseFloat($returnRange.val()) || 8.5) / 100;
        const years = parseInt($yearsRange.val(), 10) || 25;
        const etfFee = (parseFloat($etfRange.val()) || 0.15) / 100;
        const activeFee = (parseFloat($activeRange.val()) || 1.80) / 100;

        $initialDisplay.text(formatMoney(initial));
        $monthlyDisplay.text(formatMoney(monthly) + ' ' + unitPerMonth);
        $returnDisplay.text((grossReturn * 100).toFixed(1) + '%');
        $yearsDisplay.text(years + ' ' + unitYears);
        $etfDisplay.text((etfFee * 100).toFixed(2) + '%');
        $activeDisplay.text((activeFee * 100).toFixed(2) + '%');

        const netEtfReturn = Math.max(0, grossReturn - etfFee);
        const netActiveReturn = Math.max(0, grossReturn - activeFee);

        const labels = ['0 ' + unitYears];
        const grossData = [Math.round(initial)];
        const etfData = [Math.round(initial)];
        const activeData = [Math.round(initial)];

        let bGross = initial;
        let bEtf = initial;
        let bActive = initial;

        for (let y = 1; y <= years; y++) {
            for (let m = 1; m <= 12; m++) {
                bGross = (bGross + monthly) * (1 + grossReturn / 12);
                bEtf = (bEtf + monthly) * (1 + netEtfReturn / 12);
                bActive = (bActive + monthly) * (1 + netActiveReturn / 12);
            }
            labels.push(y + ' ' + unitYears);
            grossData.push(Math.round(bGross));
            etfData.push(Math.round(bEtf));
            activeData.push(Math.round(bActive));
        }

        const finalEtf = etfData[etfData.length - 1];
        const finalActive = activeData[activeData.length - 1];
        const lostToFees = finalEtf - finalActive;
        const lostPct = finalEtf > 0 ? ((lostToFees / finalEtf) * 100).toFixed(1) : '0.0';

        $('#fee-kpi-loss').text('-' + formatMoney(lostToFees));
        $('#fee-kpi-loss-pct').text(lostPct + '%');
        $('#fee-kpi-etf').text(formatMoney(finalEtf));
        $('#fee-kpi-active').text(formatMoney(finalActive));

        const feeDiff = ((activeFee - etfFee) * 100).toFixed(2);
        const realityMsg = realityTmpl
            .replace('{feeDiff}', feeDiff)
            .replace('{lostPct}', lostPct)
            .replace('{lostAmount}', formatMoney(lostToFees));
        $('#fee-reality-text').text(realityMsg);

        renderChart(labels, grossData, etfData, activeData);
    }

    function renderChart(labels, grossData, etfData, activeData) {
        const isDark = $('body').hasClass('dark') || $('body').attr('data-layout-mode') === 'dark';

        const options = {
            series: [
                { name: seriesGross, data: grossData },
                { name: seriesEtf, data: etfData },
                { name: seriesActive, data: activeData }
            ],
            chart: {
                type: 'area',
                height: 280,
                toolbar: { show: false },
                animations: { enabled: true, speed: 400 }
            },
            colors: ['#74788d', '#34c38f', '#f46a6a'],
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.35,
                    opacityTo: 0.05,
                    stops: [0, 90, 100]
                }
            },
            stroke: {
                curve: 'smooth',
                width: [2, 3, 3],
                dashArray: [4, 0, 0]
            },
            dataLabels: { enabled: false },
            xaxis: {
                categories: labels,
                labels: { style: { colors: isDark ? '#a6b0cf' : '#74788d' } }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        if (val >= 1000000) return (val / 1000000).toFixed(1) + 'M ' + symbol;
                        if (val >= 1000) return (val / 1000).toFixed(0) + 'k ' + symbol;
                        return val + ' ' + symbol;
                    },
                    style: { colors: isDark ? '#a6b0cf' : '#74788d' }
                }
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return formatMoney(val);
                    }
                }
            },
            legend: {
                position: 'top',
                horizontalAlign: 'right',
                labels: { colors: isDark ? '#a6b0cf' : '#74788d' }
            },
            grid: {
                borderColor: isDark ? '#32394e' : '#f1f1f1'
            }
        };

        const chartEl = document.querySelector('#fee-impact-chart');
        if (!chartEl) return;

        if (chartInstance) {
            chartInstance.updateOptions(options);
        } else {
            chartInstance = new ApexCharts(chartEl, options);
            chartInstance.render();
        }
    }

    // Input listeners
    $initialRange.add($monthlyRange).add($returnRange).add($yearsRange).add($etfRange).add($activeRange).on('input', calculate);

    // Currency Switcher
    function setFeeCurrency(btn, isDropdown) {
        currency = $(btn).data('currency-code');
        symbol = $(btn).data('symbol') || '$';

        if (isDropdown) {
            $('#fee-currency-tabs > button[data-currency-code]').removeClass('active');
            $('.fee-currency-dropdown-item').removeClass('active');
            $(btn).addClass('active');
            $('.fee-more-currencies-btn').addClass('active');
            $('#fee-active-custom-currency').text(`${symbol} ${currency}`);
        } else {
            $('#fee-currency-tabs button').removeClass('active');
            $(btn).addClass('active');
            $('.fee-more-currencies-btn').removeClass('active');
            $('.fee-currency-dropdown-item').removeClass('active');
            $('#fee-active-custom-currency').html(`
                <span class="d-none d-sm-inline">${textMoreCurrencies}</span>
                <span class="d-sm-none">${textMoreShort}</span>
            `);
        }

        const defInitial = parseFloat($(btn).data('initial')) || 10000;
        const defMonthly = parseFloat($(btn).data('monthly')) || 500;

        $initialRange.val(defInitial);
        $monthlyRange.val(defMonthly);

        if (currency === 'UAH' || currency === 'CZK') {
            $initialRange.attr({ min: 10000, max: 2000000, step: 25000 });
            $monthlyRange.attr({ min: 1000, max: 100000, step: 1000 });
        } else if (currency === 'PLN') {
            $initialRange.attr({ min: 2000, max: 250000, step: 2500 });
            $monthlyRange.attr({ min: 200, max: 15000, step: 100 });
        } else {
            $initialRange.attr({ min: 1000, max: 100000, step: 1000 });
            $monthlyRange.attr({ min: 50, max: 3000, step: 50 });
        }

        calculate();
    }

    $('#fee-currency-tabs > button[data-currency-code]').on('click', function () {
        setFeeCurrency(this, false);
    });

    $(document).on('click', '.fee-currency-dropdown-item', function (e) {
        e.preventDefault();
        setFeeCurrency(this, true);
    });

    calculate();
});

